import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconDrinkStyle0 = cosmosIconCss;

const CosmosIconDrink$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDrink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'cbb442cc4b287cd52f1006000eb8c98f64098cb2', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '475b495f00da1ad44eae821aa41b3f98a2425816', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7ee055efe7738dd0d75d6213451465f31f454bd0', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M16.5 2h-3.123a.5.5 0 0 0-.464.314L12.2 4.106A7.388 7.388 0 0 0 11 4C8.2 4 6 5.5 6 7.411c0 .865.933 8.882.933 8.882C7.108 17.853 8.686 19 10.925 19h.15c2.239 0 3.817-1.147 3.992-2.707 0 0 .933-8.017.933-8.882a3.343 3.343 0 0 0-2.349-2.9l.4-1.015H16.5A.5.5 0 0 0 17 3v-.5a.5.5 0 0 0-.5-.5Zm-2.932 14.254c-.075.7-1.066 1.246-2.493 1.246h-.15c-1.427 0-2.418-.546-2.493-1.246l-.667-6.242c.99.547 2.104.827 3.235.811a6.492 6.492 0 0 0 3.235-.811l-.667 6.242Zm.954-8.843c0 .9-1.447 1.912-3.522 1.912-2.075 0-3.522-1.008-3.522-1.912C7.478 6.507 8.925 5.5 11 5.5c.21.002.42.014.63.038l-.594 1.494a.5.5 0 0 0 .279.65l.464.186a.5.5 0 0 0 .649-.279L13.1 5.9c.883.378 1.422.962 1.422 1.511Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconDrinkStyle0; }
}, [1, "cosmos-icon-drink", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-drink"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-drink":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDrink$1);
            }
            break;
    } });
}

const CosmosIconDrink = CosmosIconDrink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDrink, defineCustomElement };
